import { t, useLanguage } from "@/i18n/LanguageContext";import { motion } from "framer-motion";
import { useSite } from "@/context/SiteContext";
import DynIcon from "@/components/DynIcon";
import Marquee from "@/components/Marquee";
import { Reveal, Eyebrow, DecorativeStripe } from "@/components/Reveal";

export default function ChiSiamo() {useLanguage();
  const { content } = useSite();
  const paragraphs = content.about.text.split("\n\n");

  return (
    <main data-testid="chi-siamo-page" className="[overflow-wrap:anywhere]">
      <section className="relative bg-[#F8FAFC] pb-16 pt-20 lg:pt-28">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <Eyebrow>{t("Chi siamo")}</Eyebrow>
          <h1 className="mt-4 font-display text-4xl font-bold tracking-tight text-brand-navydeep sm:text-5xl lg:text-6xl" data-testid="about-title">
            <span className="block overflow-hidden pb-1">
              <motion.span className="block" initial={{ y: "110%" }} animate={{ y: 0 }} transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}>
                {t(content.about.title)}
              </motion.span>
            </span>
          </h1>
        </div>
        <DecorativeStripe testId="about-header-decorative-stripe" />
      </section>

      <section className="bg-white py-16 lg:py-24" data-testid="about-story">
        <div className="mx-auto grid max-w-7xl items-start gap-12 px-4 sm:px-6 lg:grid-cols-5 lg:px-8">
          <Reveal className="lg:col-span-2">
            <div className="relative">
              <div className="absolute -right-4 -top-4 h-full w-full rounded-2xl border-2 border-brand-lime" />
              <img data-testid="about-team-image" src={content.about.image} alt={t("Riunione tecnica in uno studio di ingegneria")} className="img-spotlight relative aspect-[4/5] w-full rounded-2xl object-cover" />
            </div>
          </Reveal>
          <div className="lg:col-span-3">
            {t(paragraphs.map((p, i) =>
            <Reveal key={i} delay={i * 0.1}>
                <p className={`leading-relaxed ${i === 0 ? "text-lg font-semibold text-brand-navydeep" : "mt-5 text-slate-600"}`}>{t(p)}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-white py-20 lg:py-28" data-testid="organigram-section">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <Reveal><Eyebrow>{t("La struttura")}</Eyebrow></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-brand-navydeep sm:text-4xl">{t("Organigramma societario")}

            </h2>
          </Reveal>
          {t((() => {
            const org = content.organigram || [];
            const [top, ...rest] = org;
            return (
              <>
                {top &&
                <Reveal delay={0.15}>
                    <div className="mx-auto mt-12 max-w-md">
                      <div data-testid="organigram-card-0" className="overflow-hidden rounded-2xl bg-brand-navydeep text-center text-white shadow-lg">
                        {t(top.image && <img src={top.image} alt={t(top.title)} className="aspect-[16/9] w-full object-cover" />)}
                        <div className="p-7">
                          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-brand-lime text-brand-navydeep">
                            <DynIcon name={top.icon} className="h-6 w-6" />
                          </div>
                          <h3 className="font-display text-lg font-bold">{t(top.title)}</h3>
                          <p data-testid="organigram-detail-0" className="mt-2 text-sm leading-relaxed text-white/70">{t(top.detail)}</p>
                        </div>
                      </div>
                      <div className="mx-auto h-8 w-px bg-slate-300" data-testid="organigram-connector" />
                    </div>
                  </Reveal>
                }
                <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
                  {t(rest.map((o, i) =>
                  <Reveal key={i} delay={i * 0.06}>
                      <div data-testid={`organigram-card-${i + 1}`} className="group h-full overflow-hidden rounded-2xl border border-slate-200/80 bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-brand-lime hover:shadow-lg">
                        {t(o.image &&
                      <img src={o.image} alt={t(o.title)} className="img-spotlight aspect-[16/9] w-full object-cover" />)
                      }
                        <div className="p-7">
                          <div className="mb-5 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-brand-limelight text-brand-navy transition-colors duration-300 group-hover:bg-brand-navy group-hover:text-brand-lime">
                            <DynIcon name={o.icon} className="h-6 w-6" />
                          </div>
                          <h3 className="font-display text-lg font-bold text-brand-navydeep">{t(o.title)}</h3>
                          <p data-testid={`organigram-detail-${i + 1}`} className="mt-2 text-sm leading-relaxed text-slate-500">{t(o.detail)}</p>
                        </div>
                      </div>
                    </Reveal>
                  ))}
                </div>
              </>);

          })())}
        </div>
      </section>

      <section className="bg-[#F8FAFC] py-20 lg:py-28" data-testid="offices-section">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <Reveal><Eyebrow>{t("La struttura")}</Eyebrow></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-brand-navydeep sm:text-4xl">{t("Cinque uffici, una sola squadra")}

            </h2>
          </Reveal>
          <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {t(content.offices.map((o, i) =>
            <Reveal key={i} delay={i * 0.06}>
                <div data-testid={`office-card-${i}`} className="group h-full rounded-2xl border border-slate-200/80 bg-white p-7 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-brand-lime hover:shadow-lg">
                  <div className="mb-5 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-brand-navy text-brand-lime transition-colors duration-300 group-hover:bg-brand-lime group-hover:text-brand-navy">
                    <DynIcon name={o.icon} className="h-6 w-6" />
                  </div>
                  <h3 className="font-display text-lg font-bold text-brand-navydeep">{t(o.title)}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-500">{t(o.desc)}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <Marquee items={content.marquee} dark={false} />

      <section className="relative bg-brand-navydeep py-20 text-white lg:py-28" data-testid="network-section">
        <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:px-8">
          <div>
            <Reveal><Eyebrow light>{t("La rete")}</Eyebrow></Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-3 font-display text-3xl font-bold tracking-tight sm:text-4xl">{t("Una filiera fidelizzata, ")}
                <span className="text-brand-lime">{t("un territorio coperto")}</span>
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-6 leading-relaxed text-white/70">{t("Collaboriamo con decine di studi di progettazione e abbiamo fidelizzato nel tempo più di 50 piccole aziende di cottimisti e collaboratori: una rete che ci permette di rispondere con rapidità e qualità a ogni commessa, in ogni fase del cantiere.")}

              </p>
            </Reveal>
            <div className="mt-10 grid grid-cols-2 gap-6">
              <Reveal delay={0.25}>
                <p className="font-display text-5xl font-bold text-brand-lime">50+</p>
                <p className="mt-1 text-sm text-white/60">{t("cottimisti e collaboratori")}</p>
              </Reveal>
              <Reveal delay={0.3}>
                <p data-testid="about-total-sites" className="font-display text-5xl font-bold text-brand-lime">{content.stats.filter((stat) => ["Cantieri in essere", "Cantieri in partenza"].includes(stat.label)).reduce((sum, stat) => sum + (Number(stat.value) || 0), 0)}</p>
                <p className="mt-1 text-sm text-white/60">{t("cantieri tra attivi e in partenza")}</p>
              </Reveal>
            </div>
          </div>
          <Reveal delay={0.15}>
            <img
              src="https://images.pexels.com/photos/6615028/pexels-photo-6615028.jpeg?auto=compress&cs=tinysrgb&w=1000"
              alt={t("Progettazione e ingegneria GFC")}
              className="img-spotlight aspect-[4/3] w-full rounded-2xl object-cover" />
            
          </Reveal>
        </div>
        <DecorativeStripe testId="about-network-decorative-stripe" />
      </section>
    </main>);

}
